export default __webpack_public_path__ + "static/care_logo-big-480a43e45e8f175adcb325374ef9866a.gif";